import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ElateActionsUnions, ElateActionTypes } from '../actions/elate.actions';
import * as ElateActions from '../actions/elate.actions';
import { ElateService } from '../../service/elate.service';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ElateList } from '../../model/elate.model';

@Injectable()
export class ElateEffects {
  constructor(
    private actions: Actions<ElateActionsUnions>,
    private elateService: ElateService,
  ) { }

  getElates = createEffect(() =>
    this.actions.pipe(
      ofType(ElateActionTypes.GET_LISTING),
      exhaustMap(action => {
        return this.elateService.getElates(action.params).pipe(
          map((res: ElateList) => ElateActions.GetElatesListingSuccess({ payload: res })),
          catchError(() => of(ElateActions.GetElatesListingFailure()))
        );
      })
    )
  );

  getElatesFromUrl = createEffect(() =>
    this.actions.pipe(
      ofType(ElateActionTypes.GET_LISTING_URL),
      exhaustMap(action => this.elateService.getElateWithUrl(action.url).pipe(
        // getElateWithUrl retourne Elate[] donc on adapte au format liste minimal
        map(results => ElateActions.GetElatesListingSuccess({ payload: results })),
        catchError(() => of(ElateActions.GetElatesListingFailure()))
      ))
    )
  );

  getOne = createEffect(() =>
    this.actions.pipe(
      ofType(ElateActionTypes.GET_ONE),
      exhaustMap(action => this.elateService.getElateFromId(Number(action.id)).pipe(
        map(payload => ElateActions.GetElateSuccess({ payload })),
        catchError(() => of(ElateActions.GetElateFailure()))
      ))
    )
  );
}
